function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useCallback, useEffect, useState, useRef } from 'react';
import { useRefGetter } from '@bydesign-ui/hooks';
import { useRegion } from './useRegion';
import { usePoint } from './usePoint';
export var DEFAULT_CONVERTER = function DEFAULT_CONVERTER(val) {
  return val;
};
export function usePrecisionValue(part, type) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONVERTER;
  var parse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_CONVERTER;
  var initValue = arguments.length > 4 ? arguments[4] : undefined;
  var precision = arguments.length > 5 ? arguments[5] : undefined;
  var region = useRegion();
  var point = usePoint(part);
  var formatGetter = useRefGetter(format);
  var getValue = useCallback(function (value) {
    if (value == null || value === '') {
      return formatGetter()('');
    }

    return formatGetter()(region.getAxis(type).formatPrecisionValue(value, value));
  }, [region, type]);

  var _useState = useState(getValue(initValue)),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var innerValue = useRef(initValue);

  if (initValue !== undefined && initValue !== innerValue.current) {
    innerValue.current = initValue;
    setValue(getValue(initValue));
  } else {
    innerValue.current = undefined;
  }

  var parseGetter = useRefGetter(parse);
  var onInput = useCallback(function (val) {
    setValue(val);
    var parseValue = parseGetter()(val);

    if (isNaN(+parseValue)) {
      innerValue.current = undefined;
      return;
    }

    if (parseValue.trim() === '') {
      innerValue.current = undefined;
      region.emit('change', '');
    } else {
      innerValue.current = +parseValue;
      point.setPointValue({
        x: +parseValue,
        y: 0
      }, false);
    }
  }, []);
  var valueRef = useRefGetter(value);
  var onBlur = useCallback(function () {
    var val = parseGetter()(valueRef());

    if (val.trim() === '') {
      return;
    }

    var axis = region.getAxis(type);
    var validValue = axis.getValidValue(isNaN(+val) ? 0 : +val);
    axis.updateAxisPrecision(precision);
    var checkedValue = axis.formatPrecisionValue(validValue, validValue);
    axis.updateAxisPrecision();

    if (checkedValue !== val) {
      setValue(formatGetter()(checkedValue));
      region.emit('change', parseFloat(parseGetter()(checkedValue)));
    }
  }, [region, type, precision]);
  useEffect(function () {
    var nextMicro = function nextMicro(callback) {
      Promise.resolve().then(callback).catch(function (error) {});
    };

    var handleRepaint = function handleRepaint() {
      if (region.getInitValue && region.getInitValue instanceof Function && region.getInitValue() === undefined) {
        nextMicro(function () {
          return setValue(getValue(''));
        });
      } else {
        var _point$getPointValue = point.getPointValue(),
            x = _point$getPointValue.x;

        var _value = region.getAxis(type).formatPrecisionValue(x, x);

        nextMicro(function () {
          return setValue(formatGetter()(_value));
        });
      }
    };

    point.addListener('repaint', handleRepaint);
    return function () {
      return point.removeListener('repaint', handleRepaint);
    };
  }, [region, point, type]);
  return [value, onInput, onBlur];
}